module.exports = __webpack_public_path__ + "static/media/podcast1.cd826a54.mp3";